<template>
  <div class="register-container">
    <!-- 移动端注册 -->
    <div class="mobile-register">
      <div class="logo-section">
        <div class="logo-icon">✓</div>
        <h1 class="logo-text">TaskFlow</h1>
        <p class="logo-slogan">高效管理，轻松完成</p>
      </div>

      <div class="form-section">
        <div class="input-group">
          <label class="input-label">邮箱地址</label>
          <a-input v-model="form.email" placeholder="请输入邮箱地址" class="register-input" />
        </div>

        <div class="input-group">
          <label class="input-label">密码</label>
          <a-input-password v-model="form.password" placeholder="请输入密码" class="register-input" />
        </div>

        <div class="input-group">
          <label class="input-label">确认密码</label>
          <a-input-password v-model="form.confirmPassword" placeholder="请确认密码" class="register-input" />
        </div>
      </div>

      <a-button type="primary" class="register-button" @click="handleRegister" :loading="loading"> 注册 </a-button>

      <div class="login-link">
        <span>已有账号？</span>
        <a href="/taskflow/login" class="login-action">立即登录</a>
      </div>
    </div>

    <!-- PC端注册 -->
    <div class="pc-register">
      <div class="brand-section">
        <div class="logo-icon">✓</div>
        <h1 class="logo-text">TaskFlow</h1>
        <p class="logo-slogan">高效管理，轻松完成</p>
        <p class="brand-description">加入TaskFlow，开始高效管理您的任务， 提升工作效率，实现个人和团队的目标。</p>
      </div>

      <div class="form-section">
        <h2 class="form-title">用户注册</h2>
        <div class="input-group">
          <label class="input-label">邮箱地址</label>
          <a-input v-model="form.email" placeholder="请输入邮箱地址" class="register-input" />
        </div>

        <div class="input-group">
          <label class="input-label">密码</label>
          <a-input-password v-model="form.password" placeholder="请输入密码" class="register-input" />
        </div>

        <div class="input-group">
          <label class="input-label">确认密码</label>
          <a-input-password v-model="form.confirmPassword" placeholder="请确认密码" class="register-input" />
        </div>

        <a-button type="primary" class="register-button" @click="handleRegister" :loading="loading"> 注册 </a-button>

        <div class="login-link">
          <span>已有账号？</span>
          <a href="/taskflow/login" class="login-action">立即登录</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        email: '',
        password: '',
        confirmPassword: ''
      },
      loading: false
    };
  },
  methods: {
    handleRegister() {
      // 表单验证
      if (!this.form.email) {
        this.$message.error('请输入邮箱地址');
        return;
      }
      if (!this.form.password) {
        this.$message.error('请输入密码');
        return;
      }
      if (this.form.password !== this.form.confirmPassword) {
        this.$message.error('两次输入的密码不一致');
        return;
      }

      // 设置loading状态
      this.loading = true;

      // 调试信息
      console.log('注册请求数据:', {
        email: this.form.email,
        password: this.form.password
      });

      // 调用注册API
      this.$http
        .post('/api/auth/register', {
          email: this.form.email,
          password: this.form.password
        })
        .then(response => {
          console.log('注册响应数据:', response);
          if (response.success) {
            // 保存登录状态
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('user', JSON.stringify({ email: response.data.email }));
            // 跳转到任务列表页面
            this.$router.push('/taskflow/task-list');
            this.$message.success('注册成功');
          } else {
            this.$message.error(response.message || '注册失败');
          }
        })
        .catch(error => {
          console.error('注册失败:', error);
          this.$message.error('注册失败，请稍后重试');
        })
        .finally(() => {
          // 关闭loading状态
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less">
.register-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  padding: 20px;

  .mobile-register {
    display: none;
    max-width: 375px;
    width: 100%;
    background-color: #fff;
    border-radius: 40px;
    padding: 24px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    .logo-section {
      text-align: center;
      margin-bottom: 24px;

      .logo-icon {
        font-size: 48px;
        font-weight: 700;
        color: #4caf50;
        margin-bottom: 12px;
      }

      .logo-text {
        font-size: 28px;
        font-weight: 700;
        color: #1a1a1a;
        margin-bottom: 12px;
      }

      .logo-slogan {
        font-size: 14px;
        color: #666666;
      }
    }

    .form-section {
      margin-bottom: 24px;

      .input-group {
        margin-bottom: 20px;

        .input-label {
          display: block;
          font-size: 14px;
          font-weight: 500;
          color: #1a1a1a;
          margin-bottom: 6px;
        }

        .register-input {
          width: 100%;
          height: 44px;
          border-radius: 6px;

          // 修复输入框高度不一致问题
          .ant-input {
            height: 44px;
          }

          // 修复密码框眼睛图标垂直居中
          .ant-input-suffix {
            display: flex;
            align-items: center;
            height: 100%;
          }
        }
      }
    }

    .register-button {
      width: 100%;
      height: 48px;
      background-color: #4caf50;
      border-color: #4caf50;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 24px;
    }

    .login-link {
      text-align: center;
      font-size: 14px;

      span {
        color: #666666;
      }

      .login-action {
        color: #4caf50;
        font-weight: 600;
        margin-left: 8px;
      }
    }
  }

  .pc-register {
    display: flex;
    max-width: 800px;
    width: 100%;
    background-color: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    .brand-section {
      flex: 1;
      background-color: #4caf50;
      padding: 48px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #fff;

      .logo-icon {
        font-size: 64px;
        font-weight: 700;
        margin-bottom: 24px;
      }

      .logo-text {
        font-size: 36px;
        font-weight: 700;
        margin-bottom: 16px;
      }

      .logo-slogan {
        font-size: 16px;
        margin-bottom: 24px;
      }

      .brand-description {
        text-align: center;
        line-height: 1.5;
      }
    }

    .form-section {
      flex: 1;
      padding: 48px;

      .form-title {
        font-size: 24px;
        font-weight: 600;
        color: #1a1a1a;
        margin-bottom: 32px;
      }

      .input-group {
        margin-bottom: 24px;

        .input-label {
          display: block;
          font-size: 14px;
          font-weight: 500;
          color: #1a1a1a;
          margin-bottom: 6px;
        }

        .register-input {
          width: 100%;
          height: 44px;
          border-radius: 6px;

          // 修复输入框高度不一致问题
          .ant-input {
            height: 44px;
          }

          // 修复密码框眼睛图标垂直居中
          .ant-input-suffix {
            display: flex;
            align-items: center;
            height: 100%;
          }
        }
      }
    }

    .register-button {
      width: 100%;
      height: 48px;
      background-color: #4caf50;
      border-color: #4caf50;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 24px;
    }

    .login-link {
      text-align: center;
      font-size: 14px;

      span {
        color: #666666;
      }

      .login-action {
        color: #4caf50;
        font-weight: 600;
        margin-left: 8px;
      }
    }
  }

  // 响应式设计
  @media (max-width: 768px) {
    .mobile-register {
      display: block;
    }

    .pc-register {
      display: none;
    }
  }
}
</style>
